import React from 'react';
import { useSelector } from 'react-redux';
import GlobalLoader from '../../admin/shared/globalLoader';
import { ROLE } from '../../../utils/Constants';
import { getUser, setReturnURL } from '../../../utils/commonfunction';
import { Navigate } from 'react-router-dom';

const AdvertiserPublicRoute = ({ component: Component }) => {
    // const loaderState = useSelector((state) => state.globalLoader);

    // return (
    //     <>
    //         {
              
    //                 loaderState ?
    //                     <GlobalLoader /> :
    //                     <Component />
    //         }
    //     </>
    // )
    const userData = getUser(ROLE.ADVERTISER);
    // const userData = useSelector((state) => state.profile.profileData);
    // console.log(userData,"userData222222");

    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token){
                    setReturnURL(ROLE.ADVERTISER);
                    return <Navigate to="/" />;
                }else{
                    return <Component/>
                }
            })()}
        </>
    )
}

export default AdvertiserPublicRoute;